import React, { useEffect, useRef, useState, useCallback } from "react";
import styles from "./SingleComment.module.scss";
// import commentStyles from "../../SocialPostComponent/SocialPostComponent.module.scss";
import { getTimeAgo, serverFiles, debounce } from "../../../utils/utils";
// import ThreeDotsSVG from "../../SVGComponents/ThreeDotsSVG";
import { useDispatch, useSelector } from "react-redux";
import { API } from "service/Interceptor";
import {
  commentAPost,
  deleteAComment,
  getPostComments,
} from "../../../reducer/postsSlice";
// import DeleteSVG from "../../SVGComponents/DeleteSVG";
import NoImageSVG from "components/SVGComponents/NoImageSVG";
import { Link } from "react-router-dom";
// import LikeSVG from "../../SVGComponents/LikeSVG";
// import ReplySVG from "../../SVGComponents/ReplySVG";
import NO_IMAGE from "../../../images/NO_IMAGE.jpg";
// import ReplySVG from "components/SVGComponents/ReplySVG";
// import { setPopupState } from "reducer/globalSlice";
import SendSVG from "components/SVGComponents/SendSVG";
import DeleteSVG from "components/SVGComponents/DeleteSVG";
import Modal from "components/Modal/Modal";
// import LongDownArrow from "components/SVGComponents/LongDownArrow";

const SingleComment = ({
  key,
  isOwner,
  comment,
  post,
  commentToReply,
  setCommentToReply,
  shouldReplyButtonVisble = true,
  parentCommentId,
}) => {
  const { userProfile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  const [showAllReplies, setShowAllReplies] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [mentions, setMentions] = useState([]);
  const [isSending, setIsSending] = useState(false);

  const [mentionActive, setMentionActive] = useState(false);
  const [mentionIndex, setMentionIndex] = useState(-1);
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const textareaRef = useRef(null);

  const mentionActiveRef = useRef(mentionActive);
  const searchQueryRef = useRef(searchQuery);

  useEffect(() => {
    mentionActiveRef.current = mentionActive;
    searchQueryRef.current = searchQuery;
  }, [mentionActive, searchQuery]);

  const isCompletedMention = (textAfterAt, mentionsList) => {
    return mentionsList.some(
      (m) => textAfterAt.startsWith(m.name + " ") || textAfterAt === m.name
    );
  };

  const handleInputChange = (val, selectionStart) => {
    const textBeforeCursor = val.slice(0, selectionStart);
    const lastAtIndex = textBeforeCursor.lastIndexOf("@");
    
    if (lastAtIndex !== -1) {
      const charBeforeAt = lastAtIndex > 0 ? textBeforeCursor[lastAtIndex - 1] : "";
      const textAfterAt = textBeforeCursor.slice(lastAtIndex + 1);
      
      if (lastAtIndex === 0 || /\s/.test(charBeforeAt)) {
        if (isCompletedMention(textAfterAt, mentions)) {
          setMentionActive(false);
          setSearchQuery("");
          return;
        }
        const spaceCount = (textAfterAt.match(/\s/g) || []).length;
        if (spaceCount <= 1 && !/[\n\r]/.test(textAfterAt) && !textAfterAt.startsWith(" ") && textAfterAt.length < 30) {
          setMentionActive(true);
          setMentionIndex(lastAtIndex);
          setSearchQuery(textAfterAt);
          return;
        }
      }
    }
    
    setMentionActive(false);
    setSearchQuery("");
  };

  const fetchSuggestions = useCallback(
    debounce(async (query) => {
      if (!query.trim()) {
        setSuggestions([]);
        return;
      }
      try {
        const res = await API.get(`/api/search?search=${query.toLowerCase()}`);
        const data = res?.data?.data?.userResponse || [];
        if (
          mentionActiveRef.current &&
          searchQueryRef.current.toLowerCase() === query.toLowerCase()
        ) {
          setSuggestions(data);
        }
      } catch (error) {
        console.error("Failed to fetch suggestions:", error);
        setSuggestions([]);
      }
    }, 200),
    []
  );

  useEffect(() => {
    if (mentionActive && searchQuery) {
      fetchSuggestions(searchQuery);
    } else {
      setSuggestions([]);
    }
  }, [searchQuery, mentionActive, fetchSuggestions]);

  const handleSelectSuggestion = (user) => {
    const alias = user.userAliasId;
    const displayName = user.userType === "BUSINESS" && user.companyName 
      ? user.companyName 
      : `${user.firstName || ""} ${user.lastName || ""}`.trim();
    
    setMentions(prev => [...prev, { name: displayName, alias }]);
    
    const tag = `@${displayName}`;
    const textBeforeMention = commentText.slice(0, mentionIndex);
    const textAfterCursor = commentText.slice(textareaRef.current.selectionStart);
    const newText = `${textBeforeMention}${tag} ${textAfterCursor}`;
    setCommentText(newText);
    setMentionActive(false);
    setSearchQuery("");
    setSuggestions([]);
    
    setTimeout(() => {
      if (textareaRef.current) {
        textareaRef.current.focus();
        const cursorPosition = textBeforeMention.length + tag.length + 1;
        textareaRef.current.setSelectionRange(cursorPosition, cursorPosition);
      }
    }, 50);
  };

  const replies = comment?.reply || [];

  const visibleReplies = replies; // Logic handled in JSX

  const commentOwner = comment?.postOwner?.userAliasId;
  const isCommentOwner =
    userProfile?.userAliasId === commentOwner ||
    userProfile?.companyResponseDto?.companyAliasId === commentOwner;

  const renderCommentText = (text) => {
    if (!text) return "";
    const regex = /(@\[[^\]]+\]\([^)]+\))/g;
    const parts = text.split(regex);
    return parts.map((part, index) => {
      const match = part.match(/^@\[([^\]]+)\]\(([^)]+)\)$/);
      if (match) {
        const displayName = match[1];
        const username = match[2];
        const isSelf = userProfile?.userAliasId === username || userProfile?.companyResponseDto?.companyAliasId === username;
        return (
          <Link
            key={index}
            to={isSelf ? `/user-profile` : `/user-profile/${username}`}
            className={styles.comment_mention_link}
          >
            @{displayName}
          </Link>
        );
      }
      return part;
    });
  };

  const handleCommentReply = async () => {
    if (commentText.trim() && !isSending) {
      setIsSending(true);
      try {
        let formatted = commentText;
        mentions.forEach(m => {
          const safeName = m.name.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
          const regex = new RegExp(`@${safeName}\\b`, 'g');
          formatted = formatted.replace(regex, `@[${m.name}](${m.alias})`);
        });

        const payload = {
          id: post?.id,
          comment: formatted,
          parentId: parentCommentId || comment?.id,
        };
        await dispatch(commentAPost(payload)).unwrap();
        setCommentText("");
        setCommentToReply(null);
        setMentions([]);
        await dispatch(getPostComments({ id: post?.id })).unwrap();
      } catch (error) {
        console.error("Failed to post comment reply:", error);
      } finally {
        setIsSending(false);
      }
    }
  };

  const handleCommentDelete = async () => {
    try {
      await dispatch(
        deleteAComment({
          postId: post?.id,
          commentId: comment?.id,
        }),
      ).unwrap();

      setOpenModal(false);
      await dispatch(getPostComments({ id: post?.id })).unwrap();
    } catch (error) {
      console.error("Failed to delete comment:", error);
    }
  };

  

  return (
    <section className={styles.single_comment}>
      <div className={styles.left_comment_section}>
        <div className={styles.comment_user_image}>
          {comment?.postOwner?.profileUrl ? (
            <img
              src={serverFiles(comment?.postOwner?.profileUrl)}
              alt="owner profile"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = NO_IMAGE;
              }}
            />
          ) : (
            <NoImageSVG type="profile" height="40" width="40" />
          )}
        </div>
        <div className={styles.comment_user_details}>
          <div className={`${styles.comment_user_details_top}`}>
            {/* <div className={styles.user_Details}>
          </div> */}
            <Link
              to={
                isCommentOwner
                  ? `/user-profile`
                  : `/user-profile/${commentOwner}`
              }
              className={`${styles.comment_username}  unstyledLink`}
            >
              {comment?.postOwner?.firstName} {comment?.postOwner?.lastName}
            </Link>
            <p className={styles.comment_time}>
              {getTimeAgo(comment?.createdAt)}
            </p>
          </div>

          <p className={styles.comment_main}>{renderCommentText(comment?.comment)}</p>
          <div className={styles.comment_like_dislike_section}>
            {/* <div className={styles.comment_like}>
            <LikeSVG />
            <p>{""}</p>
          </div>

          <LikeSVG color="#888888" type="dislike" /> */}
            {shouldReplyButtonVisble ? (
              <div className={styles.comment_reply}>
                {/* <ReplySVG /> */}
                <button
                  className={styles.comment_reply_text}
                  onClick={() =>
                    setCommentToReply((prev) => {
                      const next = prev === comment?.id ? null : comment?.id;
                      if (next) {
                        const ownerName = `${comment?.postOwner?.firstName || ""} ${comment?.postOwner?.lastName || ""}`.trim();
                        setMentions([{ name: ownerName, alias: comment?.postOwner?.userAliasId }]);
                        setCommentText(`@${ownerName} `);
                      } else {
                        setCommentText("");
                        setMentions([]);
                      }
                      return next;
                    })
                  }
                >
                  Reply
                </button>
              </div>
            ) : null}
            {/* <ThreeDotsSVG color="#888888" /> */}
          </div>

          {commentToReply === comment?.id ? (
            <div className={styles.mention_suggestions_container}>
              <section className={styles.comments_input_section}>
                <textarea
                  ref={textareaRef}
                  className={styles.comment_textarea}
                  name=""
                  id=""
                  rows={1}
                  value={commentText}
                  onChange={(e) => {
                    const val = e.target.value;
                    setCommentText(val);
                    handleInputChange(val, e.target.selectionStart);
                  }}
                  placeholder="Comment"
                />
                <div className={styles.close_send_icons}>
                  <button
                    onClick={handleCommentReply}
                    className={styles.postButton}
                    disabled={isSending || !commentText.trim()}
                  >
                    {isSending ? (
                      <span className={styles.btn_spinner}></span>
                    ) : (
                      <SendSVG />
                    )}
                  </button>
                </div>
              </section>
              
              {mentionActive && suggestions.length > 0 && (
                <div className={styles.mention_suggestions_dropdown}>
                  {suggestions.map((user) => {
                    const name = user.userType === "BUSINESS" && user.companyName 
                      ? user.companyName 
                      : `${user.firstName || ""} ${user.lastName || ""}`.trim();
                    return (
                      <div
                        key={user.userAliasId}
                        className={styles.suggestion_item}
                        onClick={() => handleSelectSuggestion(user)}
                      >
                        <div className={styles.suggestion_user_image}>
                          {user.profileUrl ? (
                            <img
                              src={serverFiles(user.profileUrl)}
                              alt="user profile"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = NO_IMAGE;
                              }}
                            />
                          ) : (
                            <NoImageSVG type="profile" height="32" width="32" />
                          )}
                        </div>
                        <div className={styles.suggestion_user_info}>
                          <span className={styles.suggestion_user_name}>{name}</span>
                          <span className={styles.suggestion_user_alias}>@{user.userAliasId}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          ) : null}

          <div className={styles.nested_comment_section}>
            {showAllReplies && visibleReplies?.length ? (
              <div className={styles.nested_comment_container}>
                {visibleReplies?.map((reply, index) => {
                  return (
                    <SingleComment
                      key={reply?.id}
                      post={post}
                      comment={reply}
                      commentToReply={commentToReply}
                      setCommentToReply={setCommentToReply}
                      shouldReplyButtonVisble={true}
                      parentCommentId={parentCommentId || comment?.id}
                    />
                  );
                })}
              </div>
            ) : null}

            {/* View More Button */}
            {!showAllReplies && replies.length > 0 ? (
              <p
                className={styles.reply_toggle_Button}
                onClick={() => setShowAllReplies(true)}
              >
                View {replies.length} more replies
              </p>
            ) : null}

            {/* Show Less */}
            {showAllReplies && replies.length > 0 && (
              <p
                className={styles.reply_toggle_Button}
                onClick={() => setShowAllReplies(false)}
              >
                Hide
              </p>
            )}
          </div>
        </div>
      </div>
      {isCommentOwner && (
        <button
          className={styles.delete_comment_button}
          onClick={() => setOpenModal(true)}
        >
          <DeleteSVG width={18} height={18} color="red"/>
        </button>
      )}

      <Modal
        // height="fit-con!important"
        width="30rem"
        background="white"
        modalOpen={openModal}
        onClose={() => setOpenModal(false)}
        drawer={{
          isDrawer: true,
        }}
      >
        <div className={styles.delete_modal_container}>
          <div>
            <DeleteSVG width={40} height={40} />
            <p className={styles.delete_modal_heading}>
              Are you sure you want to delete this comment ?
            </p>
          </div>
          <div className={styles.delete_modal_buttons}>
            <button onClick={() => setOpenModal(false)}>Cancel</button>
            <button
              className={styles.confirm_delete_button}
              onClick={handleCommentDelete}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal>
    </section>
  );
};

export default SingleComment;
